/*
 * tree: tree 的数据，存放于vuex中
 * data：需要插入的数据节点组成的对象。
 */
export function getData(tree, data) {
  if (tree.id == data.id) {
    tree.nodes = data.nodes;
  } else {
    for (let i in tree.nodes) {
      if (tree.nodes[i].id == data.id) {
        tree.nodes[i].nodes = data.nodes;
        break;
      } else {
        getData(tree.nodes[i], data)
      }
    }
  }
}
//删除数据    提供id删除对应的节点
export function deleteData(tree, id) {
  if (tree.id == id) {
    tree.nodes.splice(0, 1);
  } else {
    for (let i in tree.nodes) {
      if (tree.nodes[i].id == id) {
        console.log(typeof tree.nodes[i])
        tree.nodes.splice(i, 1);
        break;
      } else {
        deleteData(tree.nodes[i], id)
      }
    }
  }
}

//根据id添加新数据  template数据模板，可以根据模态框取值
export function addDataByID(arr, id, template) {
  if (arr.id == id) {
    arr.nodes.push(template)
  } else {
    for (let i in arr.nodes) {
      if (arr.nodes[i].id == id) {
        arr.nodes[i].nodes.push(template);
        break;
      } else {
        addDataByID(arr.nodes[i], id, template)
      }
    }
  }
}

//获取节点是否load
export function getLoadState(arr, id) {
  if (arr.id == id) {
    return arr.isLoad
  } else {
    for (let i in arr.nodes) {
      if (arr.nodes[i].id == id) {
        return arr.nodes[i].isLoad
        break;
      } else {
        getLoadState(arr.nodes[i], id)
      }
    }
  }
}
//设置节点Load
export function setLoadState(arr, id) {
  if (arr.id == id) {
    arr.isLoad = true;
  } else {
    for (let i in arr.nodes) {
      if (arr.nodes[i].id == id) {
        arr.nodes[i].isLoad = true;
        break;
      } else {
        setLoadState(arr.nodes[i], id)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/treeUtils.js